// src/features/fourlink-config/components/shared/StepNavigation.jsx

import React from 'react';

export const StepNavigation = ({ 
  currentBlock, 
  currentStep, 
  maxSteps,
  onPrev, 
  onNext,
  onStepChange,
  onBlockChange
}) => {
  const getStepNames = (block) => {
    if (block === 1) {
      return [
        'Tipologías de Centros',
        'Equipos',
        'Categorías Profesionales', 
        'Planes',
        'Activos',
        'Tareas y Registros'
      ];
    }
    return [
      'Matriz Tipologías-Equipos',
      'Matriz Tipologías-Activos',
      'Matriz Tareas-Asignación',
      'Configuración Final'
    ];
  };

  const stepNames = getStepNames(currentBlock);

  return (
    <>
      <div className="mb-6">
        <div className="flex flex-wrap gap-2">
          {currentBlock === 1 ? (
            <>
              {stepNames.map((stepName, index) => (
                <button
                  key={index + 1}
                  onClick={() => {
                    onStepChange(index + 1);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className={`px-4 py-2 text-sm rounded-lg font-medium transition-all ${
                    currentStep === index + 1
                      ? 'text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  style={{
                    backgroundColor: currentStep === index + 1 ? '#3182ce' : undefined
                  }}
                >
                  {index + 1}. {stepName}
                </button>
              ))}
              <button
                onClick={() => {
                  onBlockChange(2);
                  onStepChange(1);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="px-4 py-2 text-sm rounded-lg bg-green-100 text-green-700 hover:bg-green-200 font-medium transition-all"
              >
                Bloque 2 &rarr;
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => {
                  onBlockChange(1);
                  onStepChange(6);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="px-4 py-2 text-sm rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 font-medium transition-all"
              >
                Bloque 1
              </button>
              {stepNames.map((stepName, index) => (
                <button
                  key={index + 1}
                  onClick={() => {
                    onStepChange(index + 1);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className={`px-4 py-2 text-sm rounded-lg font-medium transition-all ${
                    currentStep === index + 1
                      ? 'text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  style={{
                    backgroundColor: currentStep === index + 1 ? '#3182ce' : undefined
                  }}
                >
                  {index + 1}. {stepName}
                </button>
              ))}
            </>
          )}
        </div>
      </div>

      <div className="flex justify-between">
        <button
          onClick={onPrev}
          disabled={currentBlock === 1 && currentStep === 1}
          className="flex items-center gap-2 px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed font-medium"
        >
          &larr; Anterior
        </button>

        <button
          onClick={onNext}
          disabled={currentBlock === 2 && currentStep === maxSteps}
          className="flex items-center gap-2 px-6 py-3 text-white rounded-lg hover:opacity-90 transition-all disabled:bg-gray-300 disabled:cursor-not-allowed font-medium"
          style={{ backgroundColor: '#3182ce' }}
        >
          Siguiente &rarr;
        </button>
      </div>
    </>
  );
};